import axios from "axios"
const API_URL = process.env.REACT_APP_API_URL

const instance = axios.create({
  baseURL: API_URL,
  headers: { Accept: "application/json" },
  withCredentials: true,
  responseType: "json"
})

instance.interceptors.request.use(x => {
  x.meta = x.meta || {}
  x.meta.requestStartedAt = new Date().getTime()

  return x
})

instance.interceptors.response.use(
  x => {
    x.timings = {
      responseGenerationTime: x.headers["x-response-time"],
      responseDeliveryTime: new Date().getTime() - x.config.meta.requestStartedAt
    }
    return x
  },
  error => {
    return {
      success: false,
      data: {
        error
      }
    }
  }
)

export default instance

// eslint-disable-next-line no-unused-vars
let authAxios
export const replaceAuthAxios = _authAxios => {
  authAxios = _authAxios
}
